import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import DotsLoading from '../ui/DotsLoading';

const Form = styled.form`
  width: 100%;
 
`;

const FormGroup = styled.div`
  margin-bottom: 28px;
  
  @media (max-width: 768px) {
    margin-bottom: 24px;
  }
  
  @media (max-width: 480px) {
    margin-bottom: 20px;
  }
  
  label {
    display: block;
    color: #ffffff;
    font-size: 16px;
    margin-bottom: 8px;
    font-weight: 500;
    
    @media (max-width: 768px) {
      font-size: 15px;
      margin-bottom: 6px;
    }
    
    @media (max-width: 480px) {
      font-size: 14px;
      margin-bottom: 4px;
    }
  }
`;

const FormInput = styled.input`
  width: 100%;
  height: 55px;
  background: #1E1E35;
  border: 1px solid ${props => props.hasError ? '#F43F60' : '#1E1E35'};
  border-radius: 12px;
  padding: 0 20px;
  color: #ffffff;
  font-size: 16px;
  outline: none;
  transition: border-color 0.3s ease;
  
  &::placeholder { 
    color: rgba(255,255,255,0.6); 
  }
  
  &:focus { 
    border: 1px solid ${props => props.hasError ? '#F43F60' : '#999'}; 
  }
  
  @media (max-width: 768px) {
    height: 50px;
    padding: 0 16px;
    font-size: 15px;
    border-radius: 10px;
  }
  
  @media (max-width: 480px) {
    height: 45px;
    padding: 0 14px;
    font-size: 14px;
    border-radius: 8px;
  }
`;

const FormTextarea = styled.textarea`
  width: 100%;
  min-height: 80px;
  background: #1E1E35;
  border: 1px solid ${props => props.hasError ? '#F43F60' : '#1E1E35'};
  border-radius: 12px;
  padding: 12px 20px;
  color: #ffffff;
  font-size: 16px;
  outline: none;
  transition: border-color 0.3s ease;
  resize: vertical;
  font-family: inherit;
  
  &::placeholder { 
    color: rgba(255,255,255,0.6); 
  }
  
  &:focus { 
    border: 1px solid ${props => props.hasError ? '#F43F60' : '#999'};
  }
  
  @media (max-width: 768px) {
    min-height: 70px;
    padding: 10px 16px;
    font-size: 15px;
    border-radius: 10px;
  }
  
  @media (max-width: 480px) {
    min-height: 60px;
    padding: 8px 14px;
    font-size: 14px;
    border-radius: 8px;
  }
`;

const FormSelect = styled.select`
  width: 100%;
  height: 55px;
  background: #1E1E35;
  border: 1px solid ${props => props.hasError ? '#F43F60' : '#999'};
  border-radius: 12px;
  padding: 0 20px;
  color: #ffffff;
  font-size: 16px;
  outline: none;
  transition: border-color 0.3s ease;
  cursor: pointer;
  
  option {
    background: #1A1A1A;
    color: #ffffff;
  }
  
  &:focus { 
    border-color: ${props => props.hasError ? '#F43F60' : '#999'}; 
  }
  
  @media (max-width: 768px) {
    height: 50px;
    padding: 0 16px;
    font-size: 15px;
    border-radius: 10px;
  }
  
  @media (max-width: 480px) {
    height: 45px;
    padding: 0 14px;
    font-size: 14px;
    border-radius: 8px;
  }
`;

const AddressGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  
  @media (max-width: 480px) {
    gap: 10px;
  }
`;

const FullWidthField = styled.div`
  grid-column: 1 / -1;
`;

const CoordinatesGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  
  @media (max-width: 480px) {
    gap: 10px;
  }
`;

const RulesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  
  @media (max-width: 768px) {
    gap: 10px;
  }
  
  @media (max-width: 480px) {
    gap: 8px;
  }
`;

const RuleRow = styled.div`
  display: flex;
  align-items: start;
  gap: 8px;
  
  @media (max-width: 768px) {
    gap: 6px;
  }
  
  @media (max-width: 480px) {
    gap: 4px;
  }
`;

const RuleTextarea = styled.textarea`
  flex: 1;
  min-height: 40px;
  background: #1E1E35;
  border: 1px solid ${props => props.hasError ? '#F43F60' : '#1E1E35'};
  border-radius: 8px;
  color: #fff;
  font-size: 15px;
  padding: 8px 12px;

  &:focus {
    border: 1px solid ${props => props.hasError ? '#F43F60' : '#999'};
  }
  
  @media (max-width: 768px) {
    min-height: 35px;
    font-size: 14px;
    padding: 6px 10px;
    border-radius: 6px;
  }
  
  @media (max-width: 480px) {
    min-height: 30px;
    font-size: 13px;
    padding: 5px 8px;
    border-radius: 4px;
  }
`;

const AddButton = styled.button`
  background: #363636;
  color: #ededed;
  border: none;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 15px;
  margin-top: 8px;
  cursor: pointer;
  
  @media (max-width: 768px) {
    padding: 6px 14px;
    font-size: 14px;
    margin-top: 6px;
    border-radius: 6px;
  }
  
  @media (max-width: 480px) {
    padding: 5px 12px;
    font-size: 13px;
    margin-top: 4px;
    border-radius: 4px;
  }
`;

const RemoveButton = styled.button`
  background: #F43F60;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 6px 12px;
  font-size: 24px;
  line-height: 0;
  height: 24px;
  width: 24px;
  display: flex;
  visibility: ${props => props.disabled ? 'hidden' : 'visible'};
  align-items: center;
  justify-content: center;
  cursor: pointer;
  
  @media (max-width: 768px) {
    height: 22px;
    width: 22px;
    font-size: 22px;
    padding: 5px 10px;
    border-radius: 6px;
  }
  
  @media (max-width: 480px) {
    height: 20px;
    width: 20px;
    font-size: 20px;
    padding: 4px 8px;
    border-radius: 4px;
  }
`;

const SubmitButton = styled.button`
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #F43F60;
  border: none;
  border-radius: 12px;
  color: #EDEDED;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease;
  
  &:hover:not(:disabled) { 
    background: #E03A56; 
  }
  
  &:disabled { 
    background: #666666; 
    cursor: not-allowed; 
    opacity: 0.7; 
  }
  
  @media (max-width: 768px) {
    height: 45px;
    font-size: 16px;
    border-radius: 10px;
  }
  
  @media (max-width: 480px) {
    height: 40px;
    font-size: 15px;
    border-radius: 8px;
  }
`;

const CancelButton = styled.button`
  width: 100%;
  height: 50px;
  background: ${props => props.disabled ? '#30304A' : '#30304A'};
  border: none;
  border-radius: 12px;
  color: #EDEDED;
  font-size: 18px;
  font-weight: 600;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: background-color 0.3s ease;
  
  &:hover:not(:disabled) { 
    background: #232323; 
  }
  
  @media (max-width: 768px) {
    height: 45px;
    font-size: 16px;
    border-radius: 10px;
  }
  
  @media (max-width: 480px) {
    height: 40px;
    font-size: 15px;
    border-radius: 8px;
  }
`;

const ErrorMessage = styled.div`
  background: rgba(244, 63, 96, 0.1);
  border: 1px solid #F43F60;
  color: #F43F60;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 20px;
  font-size: 14px;
  text-align: center;
  
  @media (max-width: 768px) {
    padding: 10px 14px;
    margin-bottom: 16px;
    font-size: 13px;
    border-radius: 6px;
  }
  
  @media (max-width: 480px) {
    padding: 8px 12px;
    margin-bottom: 12px;
    font-size: 12px;
    border-radius: 4px;
  }
`;

const FieldError = styled.div`
  color: #F43F60;
  font-size: 12px;
  margin-top: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
  
  @media (max-width: 768px) {
    font-size: 11px;
    margin-top: 3px;
  }
  
  @media (max-width: 480px) {
    font-size: 10px;
    margin-top: 2px;
  }
  
  &::before {
    content: "⚠";
    font-size: 10px;
  }
`;

const SuccessMessage = styled.div`
  background: rgba(34, 197, 94, 0.1);
  border: 1px solid #22C55E;
  color: #22C55E;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 20px;
  font-size: 14px;
  text-align: center;
  
  @media (max-width: 768px) {
    padding: 10px 14px;
    margin-bottom: 16px;
    font-size: 13px;
    border-radius: 6px;
  }
  
  @media (max-width: 480px) {
    padding: 8px 12px;
    margin-bottom: 12px;
    font-size: 12px;
    border-radius: 4px;
  }
`;

const ButtonRow = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 16px;
  align-items: center;
  
  @media (max-width: 768px) {
    gap: 12px;
    margin-top: 12px;
    flex-direction: column;
  }
  
  @media (max-width: 480px) {
    gap: 8px;
    margin-top: 8px;
  }
`;

const Section = styled.div`
  background: #25253C;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
  
  @media (max-width: 768px) {
    padding: 20px;
    margin-bottom: 20px;
    border-radius: 10px;
  }
  
  @media (max-width: 480px) {
    padding: 16px;
    margin-bottom: 16px;
    border-radius: 8px;
  }
`;

const SectionTitle = styled.h3`
  color: #A1A1B5;
  font-size: 18px;
  font-weight: 500;
  margin: 0 0 20px 0;
  display: flex;
  align-items: center;
  gap: 8px;
  
  @media (max-width: 768px) {
    font-size: 16px;
    margin-bottom: 16px;
    gap: 6px;
  }
  
  @media (max-width: 480px) {
    font-size: 15px;
    margin-bottom: 12px;
    gap: 4px;
  }
`;

const UpdateSettingsForm = ({ values: initialValues, onSubmit, isSubmitting, error, success, }) => {
  const [values, setValues] = useState(initialValues);
  const [isDirty, setIsDirty] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});
  const formRef = React.useRef(null);

  useEffect(() => {
    setValues(initialValues);
    setFieldErrors({});
  }, [initialValues]);

  // Validation functions
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) return 'Email is required';
    if (!emailRegex.test(email)) return 'Please enter a valid email address';
    return null;
  };

  const validatePhone = (phone) => {
    if (!phone) return 'Phone number is required';
    
    // Remove any '-' characters
    const cleanedPhone = phone.replace(/-/g, '');
    
    // Check if contains only numbers and optionally + at start
    const phoneRegex = /^\+?\d+$/;
    if (!phoneRegex.test(cleanedPhone)) {
      return 'Phone number can only contain numbers and + symbol';
    }

    // Check length after removing dashes
    if (cleanedPhone.length < 8 || cleanedPhone.length > 15) {
      return 'Phone number must be between 8 and 15 digits';
    }

    return null;
  };

  const validateRequired = (value, fieldName) => {
    if (!value || value.trim() === '') return `${fieldName} is required`;
    return null;
  };

  const validateUrl = (url) => {
    if (!url) return null; // URL is optional
    try {
      new URL(url);
      return null;
    } catch {
      return 'Please enter a valid URL';
    }
  };

  const validateCoordinates = (value, fieldName) => {
    if (!value) return null; // Coordinates are optional
    const num = parseFloat(value);
    if (isNaN(num)) return `${fieldName} must be a valid number`;
    if (fieldName === 'Latitude' && (num < -90 || num > 90)) return 'Latitude must be between -90 and 90';
    if (fieldName === 'Longitude' && (num < -180 || num > 180)) return 'Longitude must be between -180 and 180';
    return null;
  };

  const validateForm = () => {
    const errors = {};

    // General info validation
    errors.name = validateRequired(values.name, 'Name');
    errors.email = validateEmail(values.email);
    errors.phone = validatePhone(values.phone);

    // Address validation
    errors.street = validateRequired(values.address.street, 'Street address');
    errors.city = validateRequired(values.address.city, 'City');
    errors.state = validateRequired(values.address.state, 'State');
    errors.zip = validateRequired(values.address.zip, 'ZIP code');
    errors.country = validateRequired(values.address.country, 'Country');
    errors.latitude = validateCoordinates(values.address.latitude, 'Latitude');
    errors.longitude = validateCoordinates(values.address.longitude, 'Longitude');

    // URL validation
    errors.crmEndpoint = validateUrl(values.crmEndpoint);

    // Negotiation rules validation
    values.negotiationRules.forEach((rule, idx) => {
      if (rule.trim() !== '' && rule.trim().length < 10) {
        errors[`rule_${idx}`] = 'Negotiation rule must be at least 10 characters long';
      }
    });

    console.log('All validation results:', errors);

    // Remove null values
    Object.keys(errors).forEach(key => {
      if (errors[key] === null) {
        delete errors[key];
      }
    });

    console.log('Final errors after removing nulls:', errors);
    return errors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues(prev => ({ ...prev, [name]: value }));
    setIsDirty(true);
    
    // Clear field error when user starts typing
    if (fieldErrors[name]) {
      setFieldErrors(prev => ({ ...prev, [name]: null }));
    }
    
    // Clear CRM API Key when CRM Endpoint is cleared
    if (name === 'crmEndpoint' && !value) {
      setValues(prev => ({ ...prev, crmApiKey: '' }));
    }
  };

  const handleAddressChange = (e) => {
    const { name, value } = e.target;
    setValues(prev => ({
      ...prev,
      address: {
        ...prev.address,
        [name]: value
      }
    }));
    setIsDirty(true);
    
    // Clear field error when user starts typing
    if (fieldErrors[name]) {
      setFieldErrors(prev => ({ ...prev, [name]: null }));
    }
  };

  const handleRuleChange = (idx, value) => {
    setValues(prev => {
      const rules = [...prev.negotiationRules];
      rules[idx] = value;
      return { ...prev, negotiationRules: rules };
    });
    setIsDirty(true);
  };

  const handleAddRule = () => {
    setValues(prev => ({ ...prev, negotiationRules: [...prev.negotiationRules, ''] }));
    setIsDirty(true);

  };

  const handleRemoveRule = idx => {
    setValues(prev => {
      const rules = prev.negotiationRules.length > 1 ? prev.negotiationRules.filter((_, i) => i !== idx) : prev.negotiationRules;
      return { ...prev, negotiationRules: rules };
    });
    setIsDirty(true);
  };

  const handleCancel = () => {
    setValues(initialValues);
    setIsDirty(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validate form
    const errors = validateForm();
    console.log('Validation errors:', errors);
    setFieldErrors(errors);
    
    // If there are errors, don't submit
    if (Object.keys(errors).length > 0) {
      console.log('Form has errors, preventing submission');
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      return;
    }
    
    console.log('Form is valid, submitting...');
    onSubmit(values, () => {
      setIsDirty(false);
      setFieldErrors({});
    });
  };

  return (
    <Form ref={formRef} onSubmit={handleSubmit}>
      {console.log('Form rendering, fieldErrors:', fieldErrors)}
      {error && <ErrorMessage>{error}</ErrorMessage>}
      {success && <SuccessMessage>{success}</SuccessMessage>}
      <Section>
        <SectionTitle>General Info</SectionTitle>
        <FormGroup>
          <label htmlFor="name">Name</label>
          <FormInput
            type="text"
            id="name"
            name="name"
            value={values.name}
            onChange={handleChange}
            placeholder="Enter dealer name"
            required
            hasError={!!fieldErrors.name}
          />
          {fieldErrors.name && <FieldError>{fieldErrors.name}</FieldError>}
        </FormGroup>
        <FormGroup>
          <label htmlFor="email">Email</label>
          <FormInput
            type="email"
            id="email"
            name="email"
            value={values.email}
            onChange={handleChange}
            placeholder="Enter dealer email"
            required
            disabled={true}
            readOnly={true}
            hasError={!!fieldErrors.email}
          />
          {fieldErrors.email && <FieldError>{fieldErrors.email}</FieldError>}
        </FormGroup>
        <FormGroup>
          <label htmlFor="phone">Phone</label>
          <FormInput
            type="tel"
            id="phone"
            name="phone"
            value={values.phone}
            onChange={handleChange}
            placeholder="Enter phone number"
            required
            hasError={!!fieldErrors.phone}
          />
          {fieldErrors.phone && <FieldError>{fieldErrors.phone}</FieldError>}
        </FormGroup>
      
      </Section>

      <Section>
        <SectionTitle>MarketCheck Integration</SectionTitle>
        <FormGroup>
          <label htmlFor="mc_dealer_id">MarketCheck Dealer ID</label>
          <FormInput
            type="text"
            id="mc_dealer_id"
            name="mc_dealer_id"
            value={values.mc_dealer_id}
            onChange={handleChange}
            placeholder="Enter MarketCheck dealer ID"
          />
        </FormGroup>
        <FormGroup>
          <label htmlFor="mc_website_id">MarketCheck Website ID</label>
          <FormInput
            type="text"
            id="mc_website_id"
            name="mc_website_id"
            value={values.mc_website_id}
            onChange={handleChange}
            placeholder="Enter MarketCheck website ID"
          />
        </FormGroup>
        <FormGroup>
          <label htmlFor="inventoryUrl">Inventory URL</label>
          <FormInput
            id="inventoryUrl"
            name="inventoryUrl"
            value={values.inventoryUrl}
            onChange={handleChange}
            placeholder="Enter inventory URL"
            hasError={!!fieldErrors.inventoryUrl}
          />
          {fieldErrors.inventoryUrl && <FieldError>{fieldErrors.inventoryUrl}</FieldError>}
        </FormGroup>
        <FormGroup>
          <label htmlFor="website">Website</label>
          <FormInput
            type="url"
            id="website"
            name="website"
            value={values.website}
            onChange={handleChange}
            placeholder="Enter website URL"
            hasError={!!fieldErrors.website}
          />
          {fieldErrors.website && <FieldError>{fieldErrors.website}</FieldError>}
        </FormGroup>
      </Section>

      <Section>
        <SectionTitle>Email Settings</SectionTitle>
        <FormGroup>
          <label htmlFor="leads_email">Leads Email</label>
          <FormInput
            type="email"
            id="leads_email"
            name="leads_email"
            value={values.leads_email}
            onChange={handleChange}
            placeholder="Enter leads email"
            hasError={!!fieldErrors.leads_email}
          />
          {fieldErrors.leads_email && <FieldError>{fieldErrors.leads_email}</FieldError>}
        </FormGroup>
        <FormGroup>
          <label htmlFor="backup_email">Backup Email</label>
          <FormInput
            type="email"
            id="backup_email"
            name="backup_email"
            value={values.backup_email}
            onChange={handleChange}
            placeholder="Enter backup email"
            hasError={!!fieldErrors.backup_email}
          />
          {fieldErrors.backup_email && <FieldError>{fieldErrors.backup_email}</FieldError>}
        </FormGroup>
        <FormGroup>
          <label htmlFor="backup_email2">Secondary Backup Email</label>
          <FormInput
            type="email"
            id="backup_email2"
            name="backup_email2"
            value={values.backup_email2}
            onChange={handleChange}
            placeholder="Enter secondary backup email"
            hasError={!!fieldErrors.backup_email2}
          />
          {fieldErrors.backup_email2 && <FieldError>{fieldErrors.backup_email2}</FieldError>}
        </FormGroup>
        <FormGroup>
          <label htmlFor="support_email">Support Email</label>
          <FormInput
            type="email"
            id="support_email"
            name="support_email"
            value={values.support_email}
            onChange={handleChange}
            placeholder="Enter support email"
            hasError={!!fieldErrors.support_email}
          />
          {fieldErrors.support_email && <FieldError>{fieldErrors.support_email}</FieldError>}
        </FormGroup>
      </Section>

      <Section>
        <SectionTitle>Address Information</SectionTitle>
        <FormGroup>
          <AddressGrid>
            <FullWidthField>
              <label htmlFor="street">Street Address</label>
              <FormInput
                type="text"
                id="street"
                name="street"
                value={values.address.street}
                onChange={handleAddressChange}
                placeholder="Enter street address"
                required
                hasError={!!fieldErrors.street}
              />
              {fieldErrors.street && <FieldError>{fieldErrors.street}</FieldError>}
            </FullWidthField>
            <div>
              <label htmlFor="city">City</label>
              <FormInput
                type="text"
                id="city"
                name="city"
                value={values.address.city}
                onChange={handleAddressChange}
                placeholder="Enter city"
                required
                hasError={!!fieldErrors.city}
              />
              {fieldErrors.city && <FieldError>{fieldErrors.city}</FieldError>}
            </div>
            <div>
              <label htmlFor="state">State</label>
              <FormInput
                type="text"
                id="state"
                name="state"
                value={values.address.state}
                onChange={handleAddressChange}
                placeholder="Enter state"
                required
                hasError={!!fieldErrors.state}
              />
              {fieldErrors.state && <FieldError>{fieldErrors.state}</FieldError>}
            </div>
            <div>
              <label htmlFor="zip">ZIP Code</label>
              <FormInput
                type="text"
                id="zip"
                name="zip"
                value={values.address.zip}
                onChange={handleAddressChange}
                placeholder="Enter ZIP code"
                required
                hasError={!!fieldErrors.zip}
              />
              {fieldErrors.zip && <FieldError>{fieldErrors.zip}</FieldError>}
            </div>
            <div>
              <label htmlFor="country">Country</label>
              <FormInput
                type="text"
                id="country"
                name="country"
                value={values.address.country}
                onChange={handleAddressChange}
                placeholder="Enter country"
                required
                hasError={!!fieldErrors.country}
              />
              {fieldErrors.country && <FieldError>{fieldErrors.country}</FieldError>}
            </div>
                          <CoordinatesGrid>
                <div>
                  <label htmlFor="latitude">Latitude</label>
                  <FormInput
                    type="number"
                    id="latitude"
                    name="latitude"
                    value={values.address.latitude}
                    onChange={handleAddressChange}
                    placeholder="Enter latitude"
                    step="any"
                    hasError={!!fieldErrors.latitude}
                  />
                  {fieldErrors.latitude && <FieldError>{fieldErrors.latitude}</FieldError>}
                </div>
                <div>
                  <label htmlFor="longitude">Longitude</label>
                  <FormInput
                    type="number"
                    id="longitude"
                    name="longitude"
                    value={values.address.longitude}
                    onChange={handleAddressChange}
                    placeholder="Enter longitude"
                    step="any"
                    hasError={!!fieldErrors.longitude}
                  />
                  {fieldErrors.longitude && <FieldError>{fieldErrors.longitude}</FieldError>}
                </div>
              </CoordinatesGrid>
          </AddressGrid>
        </FormGroup>
      </Section>

      <Section>
        <SectionTitle>Disclaimer</SectionTitle>
        <FormGroup>
          <label htmlFor="disclaimer">Dealer Disclaimer</label>
          <FormTextarea
            id="disclaimer"
            name="disclaimer"
            value={values.disclaimer}
            onChange={handleChange}
            placeholder="Enter dealer disclaimer text"
            hasError={!!fieldErrors.disclaimer}
          />
          {fieldErrors.disclaimer && <FieldError>{fieldErrors.disclaimer}</FieldError>}
        </FormGroup>
      </Section>

      <Section>
        <SectionTitle>CRM Integration</SectionTitle>
        <FormGroup>
          <label htmlFor="crmEndpoint">CRM Endpoint</label>
          <FormInput
            type="url"
            id="crmEndpoint"
            name="crmEndpoint"
            value={values.crmEndpoint}
            onChange={handleChange}
            placeholder="Enter CRM endpoint URL"
            hasError={!!fieldErrors.crmEndpoint}
          />
          {fieldErrors.crmEndpoint && <FieldError>{fieldErrors.crmEndpoint}</FieldError>}
        </FormGroup>
        <FormGroup>
          <label htmlFor="crmApiKey">CRM API Key</label>
          <FormInput
            type="password"
            id="crmApiKey"
            name="crmApiKey"
            value={values.crmApiKey}
            onChange={handleChange}
            placeholder={values.crmEndpoint ? "Enter CRM API key" : "Enter CRM endpoint URL first"}
            disabled={!values.crmEndpoint}
            style={{
              opacity: values.crmEndpoint ? 1 : 0.5,
              cursor: values.crmEndpoint ? 'text' : 'not-allowed'
            }}
          />
        </FormGroup>
      </Section>
      <Section>
        <SectionTitle>Negotiation Rules</SectionTitle>
        <FormGroup>
          <label style={{ color: '#9E9E9E', fontSize: '14px', marginBottom: '12px' }}>
            Define your negotiation rules and policies. These will be used by the AI system to guide negotiations with customers.
          </label>
          <RulesList>
            {values.negotiationRules.map((rule, idx) => (
              <React.Fragment key={idx}>
                <RuleRow>
                  <RuleTextarea
                    value={rule}
                    onChange={e => handleRuleChange(idx, e.target.value)}
                    placeholder={`Enter negotiation rule #${idx + 1} (e.g., "Minimum 10% down payment required", "No negotiation on certified vehicles")`}
                    hasError={!!fieldErrors[`rule_${idx}`]}
                  />
                  <RemoveButton 
                    type="button" 
                    onClick={() => handleRemoveRule(idx)} 
                    disabled={values.negotiationRules.length === 1}
                    title="Remove rule"
                  >
                    ×
                  </RemoveButton>
                </RuleRow>
                {fieldErrors[`rule_${idx}`] && <FieldError>{fieldErrors[`rule_${idx}`]}</FieldError>}
              </React.Fragment>
            ))}
            <AddButton type="button" onClick={handleAddRule}>
              + Add Negotiation Rule
            </AddButton>
          </RulesList>
        </FormGroup>
      </Section>
      <ButtonRow>
        <CancelButton type="button" onClick={handleCancel} disabled={!isDirty || isSubmitting}>Cancel</CancelButton>
        <SubmitButton 
          type="button" 
          disabled={isSubmitting}
          onClick={() => {
            console.log('Submit button clicked');
            if (isSubmitting) {
              console.log('Form is already submitting, preventing click');
              return;
            }
            
            // Manually trigger form submission
            handleSubmit({ preventDefault: () => {} });
          }}
        >
          {isSubmitting ? <DotsLoading /> : 'Save Settings'}
        </SubmitButton>
       
      </ButtonRow>
    </Form>
  );
}

export default UpdateSettingsForm; 